import { Button, FormControl, FormLabel, Stack } from '@chakra-ui/react'
import { ButtonType } from '../../../../utils/completionQueries'
import MonthYearPicker from './MonthYearPicker'

interface Props {
  value: string
  onChange: (value: string) => void
  selectedButton: ButtonType
  onButtonClick: (button: Exclude<ButtonType, null>) => void
  disabled?: boolean
}

export default function MonthSelector({
  value,
  onChange,
  selectedButton,
  onButtonClick,
  disabled,
}: Props) {
  return (
    <>
      <FormControl isRequired>
        <FormLabel>Select month</FormLabel>
        <MonthYearPicker
          value={value}
          onChange={onChange}
          disabled={selectedButton !== null || disabled}
        />
      </FormControl>
      <Stack direction='row' spacing={4} flexWrap='wrap'>
        <Button
          variant={selectedButton === 'current' ? 'solid' : 'outline'}
          onClick={() => onButtonClick('current')}
          isDisabled={disabled}
        >
          Current month
        </Button>
        <Button
          variant={selectedButton === 'last' ? 'solid' : 'outline'}
          onClick={() => onButtonClick('last')}
          isDisabled={disabled}
        >
          Last month
        </Button>
        <Button
          variant={selectedButton === 'last2' ? 'solid' : 'outline'}
          onClick={() => onButtonClick('last2')}
          isDisabled={disabled}
        >
          Last two months
        </Button>
        <Button
          variant={selectedButton === 'last3' ? 'solid' : 'outline'}
          onClick={() => onButtonClick('last3')}
          isDisabled={disabled}
        >
          Last three months
        </Button>
        <Button
          variant={selectedButton === 'last6' ? 'solid' : 'outline'}
          onClick={() => onButtonClick('last6')}
          isDisabled={disabled}
        >
          Last six months
        </Button>
      </Stack>
    </>
  )
}
